import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { interveneChatCountsAtom } from '../state/interveneAtoms';
import { interveneService } from '../services/interveneService';
import { normalizeChatCountsResponse } from '../utils/interveneApiAdapters';

export default function useChatCounts() {
  const setChatCounts = useSetRecoilState(interveneChatCountsAtom);

  const refreshChatCounts = useCallback(async (botNumber, organisationId) => {
    if (!botNumber) return;
    try {
      const res = await interveneService.getChatCounts(botNumber, organisationId);
      if (res?.status === 200) {
        setChatCounts(normalizeChatCountsResponse(res));
      }
    } catch (error) {
      console.error('Failed to load chat counts', error);
    }
  }, [setChatCounts]);

  return { refreshChatCounts };
}
